module.exports = __webpack_public_path__ + "media/images/info_icon_sm-673d3f38d0b7d6203e6e008efc668425.jpeg";